import React from "react";
import { MeasurementContainer } from "./Measurement.style";
import { Card } from "antd";
import { ReactComponent as AngleIcon } from "../../../assets/svgs/icons/angle-icon.svg";
import { ReactComponent as PointIcon } from "../../../assets/svgs/icons/point-icon.svg";
import { ReactComponent as DistanceIcon } from "../../../assets/svgs/icons/distance-icon.svg";
import { ReactComponent as HeightIcon } from "../../../assets/svgs/icons/height-icon.svg";
import { ReactComponent as CircleIcon } from "../../../assets/svgs/icons/circle-icon.svg";
import { ReactComponent as NorthIcon } from "../../../assets/svgs/icons/north-icon.svg";
import { ReactComponent as AreaIcon } from "../../../assets/svgs/icons/area-icon.svg";
import { ReactComponent as VolumeIcon } from "../../../assets/svgs/icons/volume-icon.svg";
import { ReactComponent as RemoveIcon } from "../../../assets/svgs/icons/remove-icon.svg";
import { PotreeFunc } from "./measurementUtils";

const buttons = [
  { id: 1, Icon: AngleIcon, label: "Angle Measurement", callback: PotreeFunc.angleMeasurement },
  { id: 2, Icon: PointIcon, label: "Point Measurement", callback: PotreeFunc.pointMeasurement},
  { id: 3, Icon: DistanceIcon, label: "Distance Measurement", callback : PotreeFunc.distanceMeasurement},
  { id: 4, Icon: HeightIcon, label: "Height Measurement" , callback : PotreeFunc.heightMeasurement},
  { id: 5, Icon: CircleIcon, label: "Circle Measurement", callback : PotreeFunc.circleMeasurement},
  { id: 6, Icon: NorthIcon, label: "Azimuth", callback : PotreeFunc.azimuthMeasurement},
  { id: 7, Icon: AreaIcon, label: "Area Measurement", callback : PotreeFunc.areaMeasurement},
  { id: 8, Icon: VolumeIcon, label: "Volume Measurement", callback : PotreeFunc.volumeMeasurement},
  { id: 9, Icon: RemoveIcon, label: "Remove All", callback : PotreeFunc.removeAll},
];

export default function Measurement() {
  return (
    <>
      <MeasurementContainer>
        <div className="measurement_sections">
          <Card bordered={false} style={{ width: 200 }}>
            <div className="measurement_sections-container">
              {buttons.map((button, index) => (
                <div key={button.id} className="measurement_sections-button" onClick={button?.callback}>
                  <button
                    type="button"
                    className={`measurement_addButton${
                      index === 0 ? " no-border-top" : ""
                    }`}
                  >
                    <button.Icon className="measurement_icon" />
                    {button.label}
                  </button>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </MeasurementContainer>
    </>
  );
}
